import { connect } from 'react-redux'
import ImageLibraryView from './library.jsx'
import _ from 'lodash';

import { fetchLibraryImages, invalidateLibraryImages, fetchMediaLibraryCategories, fetchMediaLibraryForCategory } from 'src/legacy/redux/actions/imageLibrary';
import { fetchExternalLibrary,resetExternalLibrary } from 'src/legacy/redux/actions/externalLibrary.jsx';
import {trackAdoptionMetricsForBannerListScreenView,trackAdoptionMetricsForBannerContentSelectedCollectionEvent} from 'src/legacy/redux/actions/adoption';

const mapStateToProps = (state, ownProps) => {
var path = state.legacyRootReducer.imageLibrary[ownProps.type] 
  return { 
    currentPage: _.get(path, 'pagination.currentPage', 0),
    totalPages: _.get(path, 'pagination.totalPages', 0),
    images: _.get(path, 'items', []),
    loading: _.get(path, 'loading', false),
    categories: _.get(path, 'categories', []),
    isExternalMediaLoading: _.get(state, 'legacyRootReducer.externalLibrary.fetching',false),
    externalMedias: _.get(state, 'legacyRootReducer.externalLibrary.records',[]),
    externalLibraryCurrentPage : _.get(state, 'legacyRootReducer.externalLibrary.currentPage',0),
    assetsPreview: _.get(state,'legacyRootReducer.asset.preview.item.pages',[]),
    collectionName: _.get(state,'legacyRootReducer.editCollection.item.name')
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchLibraryImages: (page, type, mediaType) => {
      return dispatch(fetchLibraryImages(page, type, mediaType));
    },

    invalidateLibraryImages: (type) => {
      return dispatch(invalidateLibraryImages(type));
    },

    fetchMediaLibraryCategories: (type) => {
      return dispatch(fetchMediaLibraryCategories(type));
    },
    
    fetchMediaLibraryForCategory: (categoryId, type, mediaType) => {
      return dispatch(fetchMediaLibraryForCategory(categoryId, type, mediaType));
    },

    fetchExternalLibrary: (data) => {
      return dispatch(fetchExternalLibrary(data));
    },

    resetExternalLibrary: () =>{
      return dispatch(resetExternalLibrary());
    },
    trackAdoptionMetricsForBannerContentSelectedCollectionEvent: (collectionName,bannerType,cta)=>{
      return dispatch(trackAdoptionMetricsForBannerContentSelectedCollectionEvent(collectionName,bannerType,cta))
    },
    trackAdoptionMetricsForBannerListScreenView : () =>{
      return dispatch(trackAdoptionMetricsForBannerListScreenView());
    }
  }
}

const ImageLibraryContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ImageLibraryView)

export default ImageLibraryContainer;
